import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowSortedDown } from "react-icons/ti";

const defaultImgUrl =
  "https://static.vecteezy.com/system/resources/previews/003/715/527/non_2x/picture-profile-icon-male-icon-human-or-people-sign-and-symbol-vector.jpg";
const header = ["Nombre", "Cantidad", "Unidad y medida", "Fecha y hora"];
const bodyCols = ["user", "quantity", "unit", "dateAndTime"];

const ConsHistoryTable = ({ data, updateSortedProp }) => {
  //const [data, setData] = useState(_data);
  const [sortType, setSortType] = useState("default"); //o reversed
  const [sortedColumn, setSortedColumn] = useState(-1);

  const toggleSortedType = () => {
    if (sortType === "default" || sortType === "sorted") {
      setSortType("reversed");
      updateSortedProp(`-${bodyCols[sortedColumn]}`);
    } else {
      setSortType("sorted");
      updateSortedProp(bodyCols[sortedColumn]);
    }
  };

  const onCLickSortBy = (i) => {
    if (i === sortedColumn) {
      // Si se hace clic en la misma columna, cambiar el tipo de ordenamiento
      toggleSortedType();
    } else {
      // Si se hace clic en una columna diferente, establecer la nueva columna y ordenar
      setSortedColumn(i);
      updateSortedProp(bodyCols[i]);
      setSortType("sorted");
    }
  };

  return (
    <>
      <Table className="overflow-hidden">
        <TableHead
          sx={{ display: "table-header-group", width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow sx={{ border: 0 }}>
            {header.map((columnTitle, i) => {
              return (
                <TableCell key={i} align={`${i > 0 ? "right" : ""}`}>
                  <div className="justify-between items-center flex flex-row">
                    <span className="font-poppins font-bold text-white ">
                      {columnTitle}
                    </span>
                    <span
                      className={`hover:bg-accent-green hover:opacity-90 p-1 mx-1 rounded-[50%] transition-colors ${
                        sortedColumn == i
                          ? "bg-white text-dark-green"
                          : "text-white"
                      }`}
                      onClick={() => onCLickSortBy(i)}
                    >
                      {sortedColumn == i && sortType == "reversed" ? (
                        <TiArrowSortedDown className=" w-[25px] h-[25px]" />
                      ) : (
                        <TiArrowSortedUp className=" w-[25px] h-[25px]" />
                      )}
                    </span>
                  </div>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, i) => {
            return (
              <TableRow
                key={i}
                className={`${
                  i % 2 == 0 ? "bg-white" : "bg-light-green"
                }  border-y-[2px] border-accent-green`}
              >
                {bodyCols.map((col, j) => {
                  return (
                    <TableCell key={j}>
                      <div
                        className={`${
                          j == 0 ? "justify-start" : "justify-end"
                        } flex flex-row items-center w-full`}
                      >
                        {col === "user" && (
                          <>
                            <div className="flex items-center justify-center mr-2">
                              <img
                                src={
                                  row?.user?.profileImage?.url
                                    ? process.env.REACT_APP_SERVER +
                                      row.user.profileImage.url
                                    : defaultImgUrl
                                }
                                className="w-[40px] rounded-[50%]"
                              />
                            </div>
                            <span className="font-poppins font-bold">
                              {row[col].name}
                            </span>
                          </>
                        )}
                        {col == "dateAndTime" ? (
                          <span className="font-poppins">
                            {new Date(row[col]).toLocaleString("es-PE", {
                              year: "numeric",
                              day: "numeric",
                              month: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              timeZone: "America/Lima",
                            })}
                          </span>
                        ) : (
                          col != "user" && (
                            <span className="font-poppins">{row[col]}</span>
                          )
                        )}
                      </div>
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};

export default ConsHistoryTable;
